// const BASE = 'https://rs-trello-2022.up.railway.app';
const BASE = 'https://final-react-task-backend.onrender.com';
const AUTH = `${BASE}/auth`;
const USERS = `${BASE}/users`;
const BOARDS = `${BASE}/boards`;
const BOARDS_SET = `${BASE}/boardsSet`;
const COLUMN_SET = `${BASE}/columnsSet`;
const TASK_SET = `${BASE}/tasksSet`;

export { BASE, AUTH, USERS, BOARDS, BOARDS_SET, COLUMN_SET, TASK_SET };
